<!--
 * @Description: 终止弹层
 * @Date: 2025-09-12 17:56:29
-->
<template>
  <BaseDialog
    width="550px"
    title="终止原因"
    :model-value="true"
    :show-close="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
    :show-footer="false"
  >
    <BaseTextContent>
      <BaseForm ref="formRef" label-position="right" :model="formData">
        <BaseFormItem
          label="原因类别"
          prop="auditTerminationReason"
          :rules="[
            {
              required: true,
              trigger: 'change',
              message: '请选择'
            }
          ]"
        >
          <BaseSelect
            placeholder="请选择"
            :options="TERMINATE"
            v-model="formData.auditTerminationReason"
          />
        </BaseFormItem>
        <BaseFormItem
          label="备注"
          prop="auditTerminationRemark"
          :rules="[
            {
              required: true,
              trigger: 'change',
              message: '请选择'
            }
          ]"
        >
          <BaseInput
            type="text"
            placeholder="请输入"
            v-model="formData.auditTerminationRemark"
          />
        </BaseFormItem>
      </BaseForm>
    </BaseTextContent>
    <template #footer>
      <BaseButton type="default" @click="remove">取消</BaseButton>
      <BaseButton type="primary" :click="onConfirm">保存</BaseButton>
    </template>
  </BaseDialog>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import {
  BaseForm,
  BaseButton,
  BaseTextContent,
  XrkMessage,
  BaseDialog,
  BaseFormItem,
  BaseInput,
  BaseSelect
} from 'xrk-components';
import { TERMINATE } from '../../constants';
import { AuditParams } from '../../data-source/types';

const emits = defineEmits(['success']);
const props = withDefaults(
  defineProps<{
    remove?: () => {};
    auditAjax: any;
    id: string;
  }>(),
  {}
);

const formRef = ref();
const formData = ref<AuditParams>({
  id: +props.id,
  status: 4,
  auditTerminationReason: '',
  auditTerminationRemark: ''
});

const onConfirm = async () => {
  await formRef.value.validate();
  await props.auditAjax(formData.value);
  XrkMessage.success('操作成功');
  emits('success');
  props.remove();
};
</script>
